import { socket } from "../index";

const emitCleanRoom = () => {
  socket?.emit('CLEAN_ROOM');
}

export default emitCleanRoom;